import { MediaObject } from 'types'
import validators from './base'
import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'

// Source https://learn.microsoft.com/en-us/linkedin/marketing/community-management/shares/videos-api?view=li-lms-2024-08&tabs=http

const linkedinContentValidator = (content: string): string[] => {
  const rules = {
    maxCharacters: 3000,
  }

  let errors = validators.validateTextLength(content, rules.maxCharacters)

  return errors
}

const linkedinFileValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minImages: 0,
    maxImages: 20,
  }

  return validators.validateFileCount(files, rules.minImages, rules.maxImages)
}

const linkedinVideosSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 500 * 1024 * 1024, // 500MB
  }

  return validators.validateVideosSize(files, rules.maxSize, 'MB')
}

const linkedinImageSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 10 * 1024 * 1024, // 10MB
  }

  return validators.validateImagesSize(files, rules.maxSize, 'MB')
}

const linkedinDurationValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minDuration: 3,
    maxDuration: 1800, // 30 minutes
  }

  return validators.validateVideosDuration(files, rules.minDuration, rules.maxDuration)
}

const linkedinAspectRatioValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minAspectRatio: 0.42,
    maxAspectRatio: 2.4,
  }

  const labels = {
    minAspectRatio: '1:2.4',
    maxAspectRatio: '2.4:1',
  }

  return validators.validateVideosAspectRatio(
    files,
    rules.minAspectRatio,
    rules.maxAspectRatio,
    labels.minAspectRatio,
    labels.maxAspectRatio,
  )
}

const linkedinFormatValidator = (_files: MediaObject[]): string[] => {
  return []
}

const linkedinVideosCountValidator = (files: MediaObject[]): string[] => {
  return validators.validateVideosCount(files, 0, 1)
}

const linkedinPostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const linkedinValidators = {
  validateContent: linkedinContentValidator,
  validateFiles: linkedinFileValidator,
  validateVideosSize: linkedinVideosSizeValidator,
  validateImagesSize: linkedinImageSizeValidator,
  validateVideosDuration: linkedinDurationValidator,
  validateVideosAspectRatio: linkedinAspectRatioValidator,
  validateVideosFormat: linkedinFormatValidator,
  validateVideosCount: linkedinVideosCountValidator,
  validatePostSettings: linkedinPostSettingsValidator,
}

export default linkedinValidators
